<template>
    <div>
      <div class="rounded-lg p-2 bg-amber-100">
        <div class="font-bold modal-header text-lg text-amber-500">
          <slot name="header">
            {{ header }}
          </slot>
        </div>

        <div class="modal-body p-2">
          <slot name="body">
            <div>
              <p class=" text-textObservacion font-bold pt-1 text-xl">Observacion 1</p>
              <p>Texto texto texto texto texto texto texto texto texto texto texto texto texto texto texto texto texto
                texto texto texto texto texto texto texto</p>
            </div>
            <div>
              <p class=" text-textObservacion font-bold pt-1 text-xl">Observacion N</p>
              <ul>
                <li>A-Z 1-9</li>
                <li>A-Z 1-9</li>
                <li>A-Z 1-9</li>
              </ul>
            </div>
          </slot>
        </div>

        <div class="modal-footer">
          <slot name="footer">
          </slot>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  props: {
    header: {
      Type: String,
      default: 'Observaciones'
    },

    data: () => ({
      header: 'example',
      body: 'example body'
    })
  }
}
</script>
